module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__10-cfe2aeef44bc3276f4d3ab78d6e87287.jpg";